/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const de_register_car__register_error = /** @type {(inputs: {}) => string} */ () => {
	return `Beim Speichern ist ein Fehler aufgetreten. Könnten Sie den Vorgang bitte wiederholen?`
};

const en_register_car__register_error = /** @type {(inputs: {}) => string} */ () => {
	return `There was an error while saving. Can you try again?`
};

const es_register_car__register_error = /** @type {(inputs: {}) => string} */ () => {
	return `Ha habido un fallo al guardar. Por favor, vuelve a intentarlo.`
};

const fr_register_car__register_error = /** @type {(inputs: {}) => string} */ () => {
	return `Il y a eu une erreur lors de l’enregistrement. Pouvez-vous réessayer ?`
};

const it_register_car__register_error = /** @type {(inputs: {}) => string} */ () => {
	return `Si è verificato un errore durante la registrazione. Puoi riprovare?`
};

const nl_register_car__register_error = /** @type {(inputs: {}) => string} */ () => {
	return `Er is een fout opgetreden tijdens de registratie. Kunt u het nog eens proberen?`
};

const pt_register_car__register_error = /** @type {(inputs: {}) => string} */ () => {
	return `Ocorreu um erro durante a gravação. Pode tentar novamente?`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
export const register_car__register_error = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.register_car__register_error(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("register_car__register_error", locale)
	if (locale === "de") return de_register_car__register_error(inputs)
	if (locale === "en") return en_register_car__register_error(inputs)
	if (locale === "es") return es_register_car__register_error(inputs)
	if (locale === "fr") return fr_register_car__register_error(inputs)
	if (locale === "it") return it_register_car__register_error(inputs)
	if (locale === "nl") return nl_register_car__register_error(inputs)
	return pt_register_car__register_error(inputs)
};